export default __webpack_public_path__ + "images/9f66449ae3fea26cc846182e496ef78c.svg";